import { Link } from "react-router-dom";

// VOY-482: tiers + copy from the Subscription Architecture spec.
const tiers = [
  {
    name: "Family",
    annual: "$79.99",
    monthly: "$6.66",
    tagline: "Four travelers, full features. Add seats up to eight.",
    features: [
      "Up to 4 travelers (add-ons to 8 at $14.99/seat)",
      "Unlimited zero-markup bookings",
      "AI Companion",
      "Gaming layer (Coming soon)",
      "Group booking (Coming soon)",
    ],
    cta: "Become a member",
    ctaVariant: "ghost" as const,
    featured: false,
  },
  {
    name: "Pro",
    annual: "$49.99",
    monthly: "$4.16",
    tagline: "For serial travelers. Everything you need, alone.",
    badge: "MOST POPULAR",
    features: [
      "Unlimited zero-markup bookings",
      "AI Companion on every trip",
      "Gaming layer · status tier (Coming soon)",
      "Group booking, unlimited (Coming soon)",
    ],
    cta: "Become a member",
    ctaVariant: "primary" as const,
    featured: true,
  },
  {
    name: "Basic",
    annual: "$29.99",
    monthly: "$2.49",
    tagline: "Three trips a year, zero markup on each.",
    features: [
      "3 bookings per year",
      "Zero markup on each booking",
      "Group booking, 1 per year (Coming soon)",
    ],
    cta: "Get Basic",
    ctaVariant: "ghost" as const,
    featured: false,
  },
];

export function Pricing() {
  return (
    <section className="sec" id="pricing">
      <div className="section-head">
        <div className="eyebrow"><span className="dot" /> Membership</div>
        <h2>
          Pay Voy <em>once</em>. Keep the rest.
        </h2>
        <p>One flat annual membership. Members book at the supplier&apos;s price plus a flat 4% transaction fee, with no markup.</p>
      </div>
      <div className="pricing">
        {tiers.map((t) => (
          <div key={t.name} className={`tier${t.featured ? " featured" : ""}`}>
            <div className="tname">
              {t.name}
              {t.badge && <span className="pill">{t.badge}</span>}
            </div>
            <div className="price-big">
              {t.annual}
              <span className="cycle">/yr</span>
            </div>
            <p className="tagline">
              {t.tagline}{" "}
              <span style={{ opacity: 0.7 }}>≈ {t.monthly}/mo</span>
            </p>
            <ul>
              {t.features.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
            <Link
              to="/subscription"
              className={`tier-cta ${t.ctaVariant}`}
            >
              {t.cta}
            </Link>
          </div>
        ))}
      </div>
      <div
        style={{
          marginTop: 32,
          display: "flex",
          flexDirection: "column",
          gap: 8,
          alignItems: "center",
          textAlign: "center",
          fontSize: 14,
          color: "var(--v6-fg-body)",
        }}
      >
        <Link
          to="/auth/sign-in"
          style={{
            color: "var(--v6-fg-strong)",
            textDecoration: "underline",
            textUnderlineOffset: 4,
          }}
        >
          Start free →
        </Link>
        {/* TODO: route to /for-business when that page exists. */}
        <Link
          to="/subscription"
          style={{ color: "var(--v6-fg-muted)", textDecoration: "none" }}
        >
          For teams? Voy for Organizations →
        </Link>
      </div>
    </section>
  );
}
